/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.11.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';

export const InputSearchStyled = styled.div.attrs({
    className: 'input-search',
})`
    position: relative;
`;

export const InputSearchFoundItemsStyled = styled.div.attrs({
    className: 'input-search__found-items',
})`
    position: absolute;
    z-index: 10;
    width: 100%;
    background-color: ${colors.backgroundColorWhite};
`;


export const InputSearchFoundItemStyled = styled.div.attrs({
    className: 'input-search__found-item',
})`
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 4px 8px 4px;
    ${fonts.textSmall};

    &:hover {
        background: ${colors.borderColorDisabled};
    }

    &:first-child {
        padding-top: 8px;
    }

    &:last-child {
        padding-bottom: 8px;
    }

    .input-search__found-item-highlight {
        background: transparent;
        ${fonts.textSmallBold};
        line-height: 1;
    }
`;
